@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package farmafreelance.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val farmafreelance_logo: DrawableResource by 
      lazy { init_farmafreelance_logo() }

  public val farmyno00: DrawableResource by 
      lazy { init_farmyno00() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("farmafreelance_logo", CommonMainDrawable0.farmafreelance_logo)
  map.put("farmyno00", CommonMainDrawable0.farmyno00)
}

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.farmafreelance_logo: DrawableResource
  get() = CommonMainDrawable0.farmafreelance_logo

private fun init_farmafreelance_logo(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:farmafreelance_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/drawable/farmafreelance_logo.png", -1, -1),
    )
)

internal val Res.drawable.farmyno00: DrawableResource
  get() = CommonMainDrawable0.farmyno00

private fun init_farmyno00(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:farmyno00",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/drawable/farmyno00.png", -1, -1),
    )
)
